<section
  class="profile-screen tw-w-full tw-flex tw-rounded-[13px] tw-overflow-hidden"
  data-cy="profile-screen"
>
  <!-- Left sidebar (Profile panel) -->
  <!-- tw-bg-[#FFFFFF]
  tw-border
  tw-border-[#E0E6EE] -->
  <aside
    class="
      profile-sidebar
      tw-w-[300px]
      tw-shrink-0
      tw-rounded-[12px]
      tw-p-[18px]
      tw-pt-[0px]
      tw-mr-[18px]
    "
  >
    <!-- Heading -->
    <div
      class="
        profile-tab-strip
        tw-flex
      "
    >
      <div
        class="
          profile-tab-pill
          tw-relative
          tw-bottom-[-11px]
          tw-z-[-1]
          tw-capitalize
          tw-w-[137px]
          tw-bg-[#769ED1]
          tw-text-center
          tw-text-[18px]
          tw-text-[#FFFFFF]
          tw-rounded-[4px]
          tw-pt-[5px]
          tw-pb-[12px]
          tw-px-[5px]
        "
      >
        {{ 'ui.shell.profile' | translate: 'Profile' }}
      </div>
    </div>
    <!-- <header class="heading-section tw-relative tw-mb-[16px]">
      <h2
        class="
          tw-text-[20px]
          tw-font-bold
          tw-text-[#3B3B3B]
          tw-tracking-[1px]
        "
        data-cy="profile-header"
      >
        Profile
      </h2>
      <button
        type="button"
        (click)="close()"
        class="
          close
          tw-absolute
          tw-top-[2px]
          tw-right-0
          tw-text-[14px]
          tw-text-[#3B3B3B]
          tw-capitalize
          tw-cursor-pointer
          tw-bg-transparent
          tw-border-0
        "
        data-cy="profile-close-button"
      >
        Close
      </button>
    </header> -->

    <!-- Funding / balance -->
    <div class="funding-section tw-rounded-[12px] tw-bg-[#F0F0F0] tw-p-[14px] tw-mb-[14px]">
      <div
        class="account-row tw-bg-[#E4ECF7] tw-rounded-[6px] tw-p-[8px_14px] tw-mb-[10px] tw-flex tw-items-center tw-justify-between"
      >
        <div class="tw-min-w-0">
          <p class="label tw-text-[13px] tw-text-[#3B3B3B]" data-cy="profile_account_balance_text">
            {{ 'ui.account.account.balance' | translate: 'Account Balance' }}
          </p>
          <div class="content" data-cy="prof_acct_bal">
            <span
              class="currency tw-font-bold tw-text-[15px] tw-mr-[8px]"
              data-cy="profile_account_usd_text"
            >USD</span>
            <span
              class="amount tw-font-bold tw-text-[22px] tw-text-[#D64C42]"
              data-cy="profile_account_balance_number"
            >
              {{ balance | numberWithCommas }}
            </span>
          </div>
        </div>
        <!-- <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-acct-arrow">
          expand_more
        </mat-icon> -->
      </div>

      <div
        class="promo-row tw-bg-[#E4ECF7] tw-rounded-[6px] tw-p-[8px_14px] tw-mb-[12px] tw-flex tw-items-center tw-justify-between"
      >
        <div class="tw-min-w-0">
          <p class="label tw-text-[13px] tw-text-[#3B3B3B]" data-cy="prof_promo_txt">
            {{ 'ui.account.promo.balance' | translate: 'Promo Balance' }}
          </p>
          <div class="content" data-cy="prof_promo_num">
            <span class="currency tw-font-bold tw-text-[15px] tw-mr-[8px]">USD</span>
            <span class="amount tw-font-bold tw-text-[22px] tw-text-[#D64C42]">
              {{ promoCount > 0 ? '150' : '0' }}
            </span>
          </div>
        </div>
        <!-- <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-promo-bal-arrow">
          expand_more
        </mat-icon> -->
      </div>

      <!-- OLD CODE -->
      <!-- <div class="account-row tw-bg-[#E4ECF7] tw-rounded-[6px] tw-p-[8px_14px] tw-mb-[10px]">
        <p class="label tw-text-[13px] tw-text-[#3B3B3B]" data-cy="profile_account_balance_text">
          Account Balance
        </p>
        <div class="content" data-cy="prof_acct_bal">
          <span
            class="currency tw-font-bold tw-text-[15px] tw-mr-[8px]"
            data-cy="profile_account_usd_text"
          >USD</span>
          <span
            class="amount tw-font-bold tw-text-[22px] tw-text-[#D64C42]"
            data-cy="profile_account_balance_number"
          >
            {{ balance | numberWithCommas }}
          </span>
        </div>
      </div>

      <div class="promo-row tw-bg-[#E4ECF7] tw-rounded-[6px] tw-p-[8px_14px] tw-mb-[12px]">
        <p class="label tw-text-[13px] tw-text-[#3B3B3B]" data-cy="prof_promo_txt">
          Promo Balance
        </p>
        <div class="content" data-cy="prof_promo_num">
          <span class="currency tw-font-bold tw-text-[15px] tw-mr-[8px]">USD</span>
          <span class="amount tw-font-bold tw-text-[22px] tw-text-[#D64C42]">
            {{ promoCount > 0 ? '150' : '0' }}
          </span>
        </div>
      </div> -->

      <button
        type="button"
        (click)="openFunding()"
        class="
          funding-row
          tw-w-full
          tw-bg-[#2F80EC]
          tw-text-[#FFFFFF]
          tw-rounded-[8px]
          tw-py-[10px]
          tw-flex
          tw-items-center
          tw-justify-center
          tw-cursor-pointer
          tw-border-0
        "
        data-cy="prof-funding"
      >
        <img src="/assets/images/profile/funding_plus_icon.svg" class="tw-inline tw-mr-[5.5px]">
        <span class="tw-text-[14px]" data-cy="profile-funding-button">
          {{ 'account.funding' | translate: 'Funding' }}
        </span>
      </button>
    </div>

    <!-- My Profile -->
    <div class="my-profile-section tw-mb-[14px]">
      <p
        class="label tw-font-bold tw-text-[13px] tw-text-[#868484] tw-mb-[6px] tw-pl-[4px]"
        data-cy="my-profile-txt"
      >
        {{ 'ui.account.my.profile' | translate: 'My Profile' }}
      </p>
      <button
        type="button"
        (click)="openProfile()"
        class="
          profile-row
          tw-bg-[#E4ECF7]
          tw-w-full
          tw-relative
          tw-flex
          tw-items-center
          tw-text-left
          tw-text-[#000000]
          tw-rounded-[12px]
          tw-p-[14px_16px]
          tw-cursor-pointer
        "
      >
        <div class="user-icon tw-relative tw-mr-[14px]" data-cy="prof-user-icon">
          <img
            src="/assets/images/profile/verify_icon_light.svg"
            class="l-mode verify tw-absolute tw-top-[-8px] tw-right-[-15px] tw-inline tw-mr-[5.5px]"
          >
          <img
            src="/assets/images/profile/verify_icon_dark.svg"
            class="
              d-mode
              verify
              tw-hidden
              tw-absolute
              tw-top-[-8px]
              tw-right-[-15px]
              tw-inline
              tw-mr-[5.5px]
            "
          >
          <span class="tw-text-[18px] tw-font-semibold">{{ userIcon || '—' }}</span>
        </div>
        <div class="user-details tw-flex-1 tw-min-w-0" data-cy="prof-user-details">
          <p class="tw-font-bold tw-text-[16px] tw-truncate" data-cy="prof-username">
            {{ userName || ('ui.account.guest.user' | translate: 'Guest User') }}
          </p>
        </div>
        <mat-icon class="chev-right !tw-text-[22px] !tw-text-[#000000]" data-cy="prof-user-arrow">
          chevron_right
        </mat-icon>
      </button>
    </div>

    <!-- My Account -->
    <div class="my-account-section tw-mb-[14px]">
      <p
        class="label tw-font-bold tw-text-[13px] tw-text-[#868484] tw-mb-[6px] tw-pl-[4px]"
        data-cy="my-acct-txt"
      >
        {{ 'main.myaccount' | translate: 'My Account' }}
      </p>

      <button
        type="button"
        (click)="openAccountSettings()"
        class="account-row tw-bg-[#F0F0F0] tw-w-full"
        [class.active]="activeSection === 'account-settings'"
        data-cy="account-settings"
      >
        <img
          src="/assets/images/profile/account_settings_icon_light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="prof-accSet-iconLight"
        >
        <img
          src="/assets/images/profile/account_settings_icon_dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <!-- <mat-icon class="!tw-text-[20px] tw-mr-[14px]">settings</mat-icon> -->
        <span class="tw-flex-1 tw-text-[14px] tw-text-left" data-cy="prof-accSet-txt">
          {{ 'ui.account.account.settings' | translate: 'Account Settings' }}
        </span>
        <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-accSet-arrow">
          chevron_right
        </mat-icon>
      </button>

      <button
        type="button"
        (click)="openAccountHistory()"
        class="account-row tw-bg-[#F0F0F0] tw-w-full"
        [class.active]="activeSection === 'account-history'"
        data-cy="open-acc-history"
      >
        <img
          src="/assets/images/account_settings/account-history-light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="prof-accHis-iconLight"
        >
        <img
          src="/assets/images/account_settings/account-history-dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <!-- <mat-icon class="!tw-text-[20px] tw-mr-[14px]">receipt_long</mat-icon> -->
        <span class="tw-flex-1 tw-text-[14px] tw-text-left" data-cy="prof-accHis-txt">
          {{ 'ui.account.account.history' | translate: 'Account History' }}
        </span>
        <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-accHis-arrow">
          chevron_right
        </mat-icon>
      </button>

      <button
        type="button"
        (click)="openBetResults()"
        class="account-row tw-bg-[#F0F0F0] tw-w-full"
        [class.active]="activeSection === 'bet-results'"
        data-cy="open-bet-result"
      >
        <img
          src="/assets/images/wager/bet_result_light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="prof-betRes-iconLight"
        >
        <img
          src="/assets/images/wager/bet_result_dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <!-- <mat-icon class="!tw-text-[20px] tw-mr-[14px]">history</mat-icon> -->
        <span class="tw-flex-1 tw-text-[14px] tw-text-left" data-cy="prof-betRes-txt">
          {{ 'ui.account.results.and.replays' | translate: 'Results and Replays' }}
        </span>
        <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-betRes-arrow">
          chevron_right
        </mat-icon>
      </button>

      <!-- Default view shows the promo panel, so keep Promo highlighted -->
      <button
        type="button"
        (click)="openPromo()"
        class="account-row promo tw-bg-[#F0F0F0] tw-w-full"
        [class.active]="activeSection === 'promo' || activeSection === 'default'"
        data-cy="open-promo"
      >
        <img
          src="/assets/images/profile/ticket_icon_light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="prof-promo-iconLight"
        >
        <img
          src="/assets/images/profile/ticket_icon_dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <!-- <mat-icon class="!tw-text-[20px] tw-mr-[14px]">local_activity</mat-icon> -->
        <span class="tw-flex-1 tw-text-[14px] tw-text-left" data-cy="prof-promo-txt">{{ 'ui.account.promo' | translate: 'Promo' }}</span>
        @if (promoCount) {
          <span class="count" data-cy="prof-promo-counter">
            <i class="badge tw-bg-[#D64C42]" data-cy="prof-promo-badge"></i> {{ promoCount }} {{ 'promos.tab.title' | translate: 'Promos' }}
          </span>
        }
        <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-promo-arrow">
          chevron_right
        </mat-icon>
      </button>

      <button
        type="button"
        (click)="openResponsibleGaming()"
        class="account-row responsible-gaming tw-bg-[#F0F0F0] tw-w-full"
        [class.active]="activeSection === 'responsible-gaming'"
        data-cy="resp-gaming"
      >
        <img
          src="/assets/images/profile/responsible_gaming_icon_light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="prof-resp-iconLight"
        >
        <img
          src="/assets/images/profile/responsible_gaming_icon_dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <!-- <mat-icon class="!tw-text-[20px] tw-mr-[14px]">favorite_border</mat-icon> -->
        <span class="tw-flex-1 tw-text-[14px] tw-text-left" data-cy="prof-resp-txt">
          {{ 'account.responsible.gaming' | translate: 'Responsible Gaming' }}
        </span>
        <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-resp-arrow">
          {{ responsibleGaming ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>

      <button
        type="button"
        (click)="openHelp()"
        class="account-row help tw-bg-[#F0F0F0] tw-w-full"
        [class.active]="activeSection === 'help'"
        data-cy="help"
      >
        <img
          src="/assets/images/profile/help_icon_light.svg"
          class="l-mode tw-inline tw-mr-[19px]"
          data-cy="prof-resp-iconLight"
        >
        <img
          src="/assets/images/profile/help_icon_dark.svg"
          class="d-mode tw-inline tw-mr-[19px]"
        >
        <!-- <mat-icon class="!tw-text-[20px] tw-mr-[14px]">favorite_border</mat-icon> -->
        <span class="tw-flex-1 tw-text-[14px] tw-text-left" data-cy="prof-resp-txt">
          {{ 'account.help' | translate: 'Help' }}
        </span>
        <mat-icon class="chev-right !tw-text-[20px] !tw-text-[#000000]" data-cy="prof-resp-arrow">
          {{ responsibleGaming ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
    </div>

    <!-- Logout -->
    <button
      type="button"
      (click)="logout()"
      class="
        logout-section
        tw-w-full
        tw-flex
        tw-items-center
        tw-justify-center
        tw-p-[12px]
        tw-cursor-pointer
        tw-bg-transparent
        tw-border-0
      "
      data-cy="logout-button"
    >
      <img
        src="/assets/images/auth/logout_icon.svg"
        alt="{{ 'ui.account.logout.icon' | translate: 'logout icon' }}"
        class="tw-mr-[10px]"
        data-cy="prof-logout-icon"
      >
      <!-- <mat-icon class="!tw-text-[20px] tw-mr-[8px] !tw-text-[#070101]">logout</mat-icon> -->
      <span class="action tw-font-bold tw-text-[14px] tw-text-[#070101]" data-cy="prof-logout-txt">
        {{ 'main.logout' | translate: 'Logout' }}
      </span>
    </button>
  </aside>

  <!-- Right-hand dynamic content -->
  <!-- tw-bg-[#FFFFFF]
  tw-border
  tw-border-[#E0E6EE] -->
  <!-- [class.promo-open]="activeSection === 'promo' || activeSection === 'default'" -->
  <!-- 'account-history-open': activeSection === 'account-history',
  'bet-results-open': activeSection === 'bet-results', -->
  <article
    [ngClass]="{
      'promo-open': activeSection === 'promo' || activeSection === 'default',
      'account-settings-open': activeSection === 'account-settings',
      'account-history-open': activeSection === 'account-history',
      'responsible-gaming-open': activeSection === 'responsible-gaming',
      'help-open': activeSection === 'help',
      'funding-open': activeSection === 'funding',
    }"
    class="
      profile-content
      tw-flex-1
      tw-min-w-0
      tw-bg-[#F9F9F9]
      tw-rounded-[12px]
      tw-p-[18px]
      tw-min-h-[420px]
      tw-mt-[44px]
    "
    data-cy="profile-content"
  >
    @switch (activeSection) {

      @case ('promo') {
        <ng-container *ngTemplateOutlet="promoTemplate"></ng-container>
      }

      @case ('account-settings') {
        <feature-mat-account-settings/>
      }

      @case ('account-history') {
        <feature-mat-account-history/>
      }

      <!-- OLD CODE - "Results and Replays" now redirects to the /results page
           (see openBetResults()), so this in-profile placeholder is no longer used -->
      <!-- @case ('bet-results') {
        <ng-container
          *ngTemplateOutlet="placeholderTemplate; context: { title: 'Betting Results' }"
        >
        </ng-container>
      } -->

      @case ('responsible-gaming') {
        <feature-mat-responsible-gaming/>
      }

      @case ('funding') {
        <feature-mat-funding (closed)="selectSection('default')"/>
      }

      @case ('help') {
        <feature-mat-help/>
      }

      @default {
        <ng-container *ngTemplateOutlet="defaultPromoTemplate"></ng-container>
      }
    }
  </article>
</section>

<!-- Default landing template -->
<ng-template #defaultPromoTemplate>
  <ng-container *ngTemplateOutlet="promoTemplate"></ng-container>
</ng-template>

<!-- Promotions / Giveaway tabbed panel -->
<ng-template #promoTemplate>
  <feature-mat-promotions></feature-mat-promotions>
</ng-template>

<!-- Generic placeholder template for sections without a dedicated panel -->
<ng-template #placeholderTemplate let-title="title">
  <header class="tw-flex tw-items-center tw-justify-between tw-mb-[14px]">
    <h3 class="tw-font-bold tw-text-[18px] tw-text-[#3B3B3B]">{{ title }}</h3>
    <!-- <button
      type="button"
      (click)="selectSection('default')"
      class="tw-text-[12px] tw-text-[#2F80EC] tw-cursor-pointer tw-bg-transparent tw-border-0"
    >
      Back to Promotions
    </button> -->
  </header>
  <div class="tw-p-[14px] tw-text-[13px] tw-text-[#6B7280]">
    {{ 'ui.account.were.working.hard.to.bring.this' | translate: 'We\'re working hard to bring this section to you! Stay tuned for updates.' }}
  </div>
</ng-template>
